import { FC, useState } from 'react';
import { typeMeetingsDoc, typeUser } from '@monorepo/models';
import { useGetIsMobile } from 'src/custom-hooks';
import { UserAssignmentsModal } from './UserAssignmentsModal';

type propsType = {
    meetingsDoc: typeMeetingsDoc;
    users: typeUser[];
};

export const UserAssignmentsButton: FC<propsType> = ({ meetingsDoc, users }) => {
    const [showUserAssignments, setShowUserAssignments] = useState(false);
    const isMobile = useGetIsMobile();

    return (
        <>
        {showUserAssignments &&
            <UserAssignmentsModal
                closeModal={() => setShowUserAssignments(false)}
                meetingsDoc={meetingsDoc}
                users={users}
            />
        }
        <div className={'hide-for-navbar'} style={{ position: 'fixed', width: '100%', zIndex: 4 }}>
            <div
                style={{
                    right: isMobile ? '20px' : '0',
                    marginTop: '110px',
                    position: 'fixed',
                    top: 0,
                    transform: isMobile ? '' : 'translateX(-50%)',
                    zIndex: 3
                }}
            >
                <button className={`btn btn-general-blue d-block ${isMobile ? 'btn-sm' : ''}`}
                    style={{ width: '140px' }}
                    onClick={() => setShowUserAssignments(true)}
                >
                    Ver por Usuario
                </button>
            </div>
        </div>
        </>
    );
}
